import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import Link from 'next/link';
import { Typography } from '@/components/shared/Typography';
import { BreadcrumbItem } from '@/lib/breadcrumbs/types';
import css from './style.module.scss';
interface Props {
  items: BreadcrumbItem[];
  className?: string;
}
const Breadcrumbs = t0 => {
  const $ = _c(11);
  const {
    items,
    className
  } = t0;
  if (items.length <= 1) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = clsx(css.breadcrumbs, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== items) {
    let t3;
    if ($[4] !== items.length) {
      t3 = (item, index) => {
        const isLast = index === items.length - 1;
        return <Typography key={`${item.label}-${index}`} className={clsx(css.item, item.truncate && css.truncatedItem)} variant="body-m" tag="li">{isLast ? <span className={css.current} aria-current="page">{item.label}</span> : item.href ? <Link href={item.href} className={clsx(css.link, item.truncate && css.truncatedLink)} title={item.truncate ? item.label : undefined}>{item.label}</Link> : <span className={css.current}>{item.label}</span>}</Typography>;
      };
      $[4] = items.length;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = items.map(t3);
    $[2] = items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <ol className={css.list}>{t2}</ol>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <nav aria-label="Breadcrumb" className={t1}>{t3}</nav>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default Breadcrumbs;